import { Category } from 'shared/types/product';
import { Facet } from 'shared/types/result';
import { FacetConfiguration, TermFacet } from 'components/gruenland/organisms/product-list/types';

interface Config {
  facets: Facet[];
  facetsConfiguration: FacetConfiguration[];
  categories: Category[];
}

const buildFacetsConfiguration = ({ facets, facetsConfiguration, categories }: Config) => {
  const externalFacetsConfiguration: Record<string, FacetConfiguration> = (facetsConfiguration ?? []).reduce(
    (acc, configuration) => ({
      ...acc,
      [configuration.key]: configuration as FacetConfiguration,
    }),
    {},
  );

  const finalFacets = facets ?? [];

  const keys = Object.keys(externalFacetsConfiguration);

  finalFacets.sort((a, b) => keys.indexOf(a.key) - keys.indexOf(b.key));

  const finalFacetsConfiguration = finalFacets
    .filter((facet) => facet.key in externalFacetsConfiguration)
    .map((facet) => {
      if (facet.key === 'categories') {
        (facet as TermFacet).terms = (facet as TermFacet).terms.map((term) => ({
          ...term,
          label: categories.find((c) => c.categoryKey === term.key)?.name ?? '',
        }));
      } else if (facet.type === 'boolean') {
        (facet as TermFacet).terms = (facet as TermFacet).terms.map((term) => ({
          ...term,
          label: externalFacetsConfiguration[facet.key].label,
        }));
      }

      return facet;
    })
    .filter(
      (facet) =>
        facet.type !== 'boolean' || !!(facet as TermFacet).terms.find((term) => term.key === 'T' && term.count > 0),
    )
    .reduce(
      (acc, configuration) => ({
        ...acc,
        [configuration.key]: {
          ...configuration,
          label: externalFacetsConfiguration[configuration.key].label,
          type: externalFacetsConfiguration[configuration.key].type,
        } as FacetConfiguration,
      }),
      {},
    );

  return finalFacetsConfiguration;
};

export default buildFacetsConfiguration;
